export const additionalTerms = [
  // 하드코딩 참조
  // src/pages/terms/TermsDetail.vue
  // src/components/signup/agreements/Agreements.vue
  {
    title: '번개입금 서비스 이용약관',
    isRequired: true,
    isAgreed: false,
    content: `
      <p data-renderer-start-pos="6"><strong data-renderer-mark="true">제 1조(목적)</strong></p>
      <p data-renderer-start-pos="16">본 약관은 (주)펀다(이하 &ldquo;회사&rdquo;라 한다)가 제공하는  번개입금 서비스(이하 &ldquo;서비스&rdquo;라 한다)와 관련하여 회사와 회원간의 권리와 의무, 책임사항 및 회원의 서비스 이용조건과 절차 등에 관한 제반 사항을 규정함을 목적으로 한다.</p>
      <p data-renderer-start-pos="212">&nbsp;</p>
      <p data-renderer-start-pos="215"><strong data-renderer-mark="true">제2조(용어의 정의)</strong></p>
      <ol class="ak-ol" data-indent-level="1">
      <li>
      <p data-renderer-start-pos="230">"회원"이라 함은 서비스에 접속하여 이 약관에 따라 회사와 이용계약을 체결하고 회사가 제공하는 서비스를 이용하는 고객을 말한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="305">"서비스"라 함은 회원의 제반 매출(카드 결제액, 배달 매출액, 기타 부수적인 수단의 매출)의 일부 혹은 전부를 매출 발생 익일에 회사의 제휴사가 회원에게 선지급하여 주는 서비스를 말한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="414">&ldquo;정산주체&rdquo;라 함은 서비스를 이용하는 회원의 사업장에서 발생한 카드 매출 및 대행결제대금 등을 회원에게 지급하는 자로 현대카드, 롯데카드, 신한카드, NH농협카드, 비씨카드, 삼성카드, KB국민카드, 하나카드, 우리카드, 배달의 민족, 요기요, 쿠팡이츠 등을 말하며, 회원에게 정산(예정)일에 정산금을 지급하는 채무자를 말한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="595">&ldquo;정산금&rdquo;이라 함은 회원이 소비자에게 판매한 재화 등 판매대금에서 정산주체의 결제수수료 및 각종 수수료, 서비스 이용료 등을 공제 한 나머지 금액을 말한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="686">&ldquo;정산(예정)일&rdquo;이라 함은 정산주체와 회원간 계약에 의하여 정산주체가 회원에서 정산금을 지급하는 날을 말한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="751">"서비스 이용료"라 함은 서비스를 이용함으로써 회원이 회사에 지불해야 하는 비용을 말한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="805">"선정산금" 이라 함은 회원이 정산주체로부터 지급받을 것으로 예상되는 정산금을 기초로, 지급 주체의 정산(예정)일보다 앞서 회사가 회원에게 지급하는 일정 비율의 금원을 말한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="907">"과정산금"은 각 "정산주체" 별로 정산금이 예정된 입금예정액보다 초과되어 입금된 금액을 말한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="965">"미정산금"은 각 "정산주체" 별로 정산금이 예정된 입금예정액보다 부족하게 들어온 금액을 말한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="1023">"매출 입금계좌"라 함은 서비스를 이용하기 위해 회원이 등록한 BNK 경남은행 계좌를 말하는 것으로 회원이 정산주체로 부터 정산금을 지급 받는 계좌를 말한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="1115">"매출 환급계좌"라 함은 회원이 서비스를 이용함으로써 회사로부터 선정산 및 과정산금에 대한 정산금을 받을 수 있는 주거래 계좌를 말한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="1195">이 약관에서 정의되지 않은 용어는 관련 법령이 정하는 바에 따른다.</p>
      </li>
      </ol>
      <p data-renderer-start-pos="1236">&nbsp;</p>
      <p data-renderer-start-pos="1239"><strong data-renderer-mark="true">제3조(이용약관의 효력 및 변경)</strong></p>
      <ol class="ak-ol" data-indent-level="1">
      <li>
      <p data-renderer-start-pos="1261">회사는 본 약관의 내용을 회원이 쉽게 알 수 있도록 서비스 가입시의 화면 또는 모바일 어플리케이션에 제공하며, 본 약관에 동의한 회원 모두에게 그 효력이 발생한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="1356">회사는 관련 법령(약관의 규제에 관한 법률, 정보 통신망 이용 촉진 및 정보 보호 등에 관한 법률 등)에 위반하지 않는 범위에서 이 약관을 개정할 수 있다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="1447">회사는 필요 시 본 약관을 개정할 수 있으며, 본 약관을 개정하는 경우 개정사유와 개정내용 및 적용일자를 명시하여 적용일 *일 이전에 모든 회원에게 공지한다. 개정된 약관은 회원이 서비스 가입 시 등록한 휴대폰 번호의 SMS 나 카카오 알림톡 또는 e-mail 로 개정 내용을 통지할 수 있다. </p>
      </li>
      <li>
      <p data-renderer-start-pos="1605">관계법령의 개정으로 인하여 긴급하게 본 약관을 변경해야할 경우, 회사는 카카오 알림톡 또는 SMS를 통하여 약관이 개정된다는 사실과 개정내용을 지체없이  *개월 이상 게시하고, 제3항에 규정된 통지방법을 준용하여 회원에게 통지한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="1733">본 약관의 개정과 관련하여 이의가 있는 회원은 서비스해지를 요청할 수 있다. 단, 개정되는 약관의 시행일 전 마지막 영업일까지 이의를 제기하지 않거나 회원탈퇴 요청을 하지 않은 회원은 개정된 약관에 동의한 것으로 본다.</p>
      </li>
      </ol>
      <p data-renderer-start-pos="1859">&nbsp;</p>
      <p data-renderer-start-pos="1862"><strong data-renderer-mark="true">제 4조(약관 외 준칙)</strong></p>
      <ol class="ak-ol" data-indent-level="1">
      <li>
      <p data-renderer-start-pos="1879">회사는 필요한 경우 특정 서비스에 적용되는 사항에 대하여 개별약관을 정하여 가입 신청서 내의 조건, 이용약관, 개인정보처리방침을 수정할 수 있으며, 해당 내용은 회원의 카카오톡이나 모바일 어플리케이션 등을 통해 공지한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="2006">제1항의 개별약관에 동의하고 특정서비스를 이용하는 경우에는 개별약관이 우선적으로 적용된다.</p>
      </li>
      </ol>
      <p data-renderer-start-pos="2060">&nbsp;</p>
      <p data-renderer-start-pos="2063"><strong data-renderer-mark="true">제 5조(회사의 의무)</strong></p>
      <ol class="ak-ol" data-indent-level="1">
      <li>
      <p data-renderer-start-pos="2079">회사는 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 서비스를 제공하기 위하여 최선을 다하여 노력한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="2160">회사는 회원으로부터 제기되는 의견이나 불만이 정당하다고 인정할 경우에는 이를 처리하여야 한다. 회원이 제기한 의견이나 불만사항의 처리결과는 당해 회원에게 회원 가입 시 입력한 휴대전화로 유선 및 문자 메세지, 카카오 알림톡을 통하여 전달한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="2312">회사는 계속적이고 안정적인 서비스 제공을 위하여 설비에 장애가 생기거나 유실된 때에는 이를 지체 없이 수리 또는 복구한다. 다만, 천재지변 또는 회사에 부득이한 사유가 있는 경우, 서비스 운영을 일시 정지할 수 있다.</p>
      </li>
      </ol>
      <p data-renderer-start-pos="2437">&nbsp;</p>
      <p data-renderer-start-pos="2440"><strong data-renderer-mark="true">제 6조(회원의 의무)</strong></p>
      <ol class="ak-ol" data-indent-level="1">
      <li>
      <p data-renderer-start-pos="2456">회원은 회사와 이용 계약을 체결 후 서비스 이용시 회사에서 규정한 이용수수료를 지급하여야 한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="2513">"서비스"에 가입 되어 있는 기간 중 서비스 이용을 위해 "카드매출 입금계좌"로 등록된 BNK 경남은행 계좌를 "회원"의 임의대로 다른 계좌로 변경하여서는 안된다. 단, 부득이하게 변경이 필요한 경우 회사에 알려 변경 목적의 사유를 밝히고 회사에 동의를 받아야 한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="2666">회원은 본 약관 및 회사가 고지하는 내용을 준수해야 하며, 이를 위반하거나 이행하지 아니하여 발생하는 모든 손해에 대한 책임을 부담해야 한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="2749">회원은 회사의 명시적 동의 없이 서비스 가입에 따른 본 약관상의 지위 또는 권리, 의무의 전부 또는 일부를 제3자에게 양도하거나 위임할 수 없으며 담보 제공 등의 목적으로 처분할 수 없다.</p>
      </li>
      </ol>
      <p data-renderer-start-pos="2858">&nbsp;</p>
      <p data-renderer-start-pos="2861"><strong data-renderer-mark="true">제 7조(서비스 이용신청)</strong></p>
      <ol class="ak-ol" data-indent-level="1">
      <li>
      <p data-renderer-start-pos="2879">회원은 회사가 정한 회원가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로써 회원가입을 신청한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="2952">회사는 회원이 서비스를 쉽게 이용할 수 있도록 회원의 정보를 관리하거나 인터넷 사이트 또는 서비스를 개선, 변경할 수 있다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="3025">회원은 서비스 이용 신청 시 회사가 지정하는 BNK 경남은행 계좌로 &ldquo;매출 입금계좌&rdquo;를 변경하여야 하며, 이에 동의하지 않을 시 서비스 제공이 제한된다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="3114">회원은 회원가입 시에 회사가 서비스를 제공함에 있어서 필요한 정보를 제공해야 하며, 회사가 그 필요에 따라 별도로 요청할 경우 요청 받은 서류를 제출해야 한다. 또한 회사는 서비스의 제공을 위해 회원에게 별도의 출금이체 서비스 이용에 대한 동의를 구할 수 있으며 회원이 이를 거부하는 경우 서비스 제공이 제한될 수 있다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="3297">회원이 사실과 다른 정보 또는 허위 정보를 기입하거나 추후 그러한 정보임이 밝혀질 경우 운영자의 권한으로 서비스 이용을 일시 정지하거나 영구정지 또는 이용 계약을 해지할 수 있다. 이로 인하여 회사 또는 제 3자에게 발생한 손해는 해당 회원이 책임을 진다. 다만, 회사의 고의나 과실에 의하여 손해가 발생한 경우에는 회사가 손해를 부담한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="3491">회사는 회원이 가입 신청한 경우 법령에 따라 이용 가능한 신용정보업자 또는 신용정보집중기관을 통하여 회원 정보 진위 여부를 확인할 수 있으며, 회사는 진위 여부를 확인할 수 없는 이용신청에 대해서는 신청자에게 증빙자료를 요청할 수 있다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="3627">회사는 그 판단에 따라 가입 신청에 대한 승낙을 유보할 수 있다. 이 경우, 회사는 가입 신청자에게 승낙유보의 사유, 승낙가능시기 또는 승낙에 필요한 추가요청정보 내지 자료 등 기타 승낙유보와 관련된 사항을 &lsquo;카카오톡(알림톡)\'이나 기타 방법을 통하여 가입 신청자에게 통지한다.</p>
      </li>
      </ol>
      <p data-renderer-start-pos="3786">&nbsp;</p>
      <p data-renderer-start-pos="3789"><strong data-renderer-mark="true">제 8조(서비스 내용)</strong></p>
      <ol class="ak-ol" data-indent-level="1">
      <li>
      <p data-renderer-start-pos="3805">회사는 회원에게 BNK 경남은행으로 입금되는 매출금을 회원의 번개입금 서비스 신청 승인일의 다음 영업일 부터 매 영업일 지급한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="3881">회사는 &ldquo;매출 입금계좌&rdquo;가 BNK 경남은행으로 모두 변경되면 회원에게 선정산금을 지급하고, 입금된 정산금에 기하여 정산주체로부터 정산금을 지급받거나 회원의 정산금 수령계좌에서 정산주체가 송금한 정산금을 회사가 지정한 계좌로 일괄 출금한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="4033">회사의 지정 계좌로 과입금액이 입금된 경우, 회사는 과입금액 수령일로부터 *영업일 이내에 해당 과입금액을 회원이 회사에 사전에 등록한 입금 계좌로 지급하거나, 차회차 선정산금에 더하여 지급한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="4145">회원이 매출 입금계좌를 BNK 경남은행으로 변경 후 정산주체에 지급할 광고비 등 기타 비용을 정산금으로 상계하거나 회사가 정산금을 출금이체하기 전에 회원이 이를 출금하는 등의 사유로 회사가 정산금의 일부 또는 전부를 수령하지 못하는 경우 회사가 수령하지 못한 정산금(이하 &lsquo;미수금액&rsquo;)은 차회차 선정산금에서 공제하거나 회원이 정산주체로부터 지급 받을 정산금에서 추가 수령할 수 있다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="4363">회사는 회원에게 서비스를 통한 지급 내용 및 기타 거래에 관한 제반 사항을 카카오 알림톡 또는 SMS를 이용해 통지하고 회원이 서비스 및 거래에 관한 모든 정보를 알 수 있도록 그 내용을 제공하여야 한다.</p>
      </li>
      </ol>
      <p data-renderer-start-pos="4519">&nbsp;</p>
      <p data-renderer-start-pos="4522"><strong data-renderer-mark="true">제 9조(서비스 이용료)</strong></p>
      <ol class="ak-ol" data-indent-level="1">
      <li>
      <p data-renderer-start-pos="4539">회사는 회원에게 번개입금서비스 이용에 대한 보수로서 &lsquo;서비스 이용료&rsquo;를 부과하고, 회사는 회원에게 지급되는 선정산금에서 이를 공제한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="4618">서비스 이용료를 조정하는 경우에는 *일 이전에 공지한 후 적용할 수 있다.</p>
      </li>
      </ol>
      <p data-renderer-start-pos="4663">&nbsp;</p>
      <p data-renderer-start-pos="4666"><strong data-renderer-mark="true">제 10조(서비스 중지)</strong></p>
      <p data-renderer-start-pos="4681">회사는 회원이 본 약관 또는 개별 계약을 위반하여 서비스 제공에 지장을 주거나 줄 우려가 있다고 판단될 경우 또는 제 11조 서비스 계약 해지 사유가 발생할 것이 예상되는 경우 서비스를 중지할 수 있다.</p>
      <p data-renderer-start-pos="4796">&nbsp;</p>
      <p data-renderer-start-pos="4799"><strong data-renderer-mark="true">제 11조(서비스 계약 해지)</strong></p>
      <ol class="ak-ol" data-indent-level="1">
      <li>
      <p data-renderer-start-pos="4819">회원이 서비스 이용 약정을 해지하고자 하는 경우 회사가 정한 방법으로 해지 신청을 해야 한다. 단 회원은 회사가 정산금을 수령하기 전 또는 미수금액이 남아 있는 경우 그 미수금액을 지급하기 전까지 임의로 서비스 이용 약정을 해지할 수 없다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="4957">회사는 다음 가) 호에 해당되는 때에는 별도의 통지 없이 서비스 이용 약정을 해지할 수 있다.</p>
      </li>
      </ol>
      <p data-renderer-start-pos="5013">가) 회원이 본 약관을 위반하여 서비스 제공에 지장을 주거나 중대한 손해를 주었을 때</p>
      <p data-renderer-start-pos="5062">나) 회원과 신용카드사 및 배달APP 간에 체결된 신용카드가맹점의 계약이 해지되거나 회사가 정한 기간 동안 이용실적이 없을 때</p>
      <p data-renderer-start-pos="5134">다) 제 10조 규정에 의하여 서비스 제공이 중지된 회원이 서비스 제공 중지일로부터 *일 이내에 중지 사유를 해소하지 아니한 때</p>
      <p data-renderer-start-pos="5207">라) 회원이 재화나 용역에 대한 신용매출 없이 카드승인 요청하는 등 부정한 매출 발생시</p>
      <p data-renderer-start-pos="5257">마) 부실, 연체, 신용도 저하, 폐업, 통장 및 카드사 압류 등의 사유발생 시</p>
      <p data-renderer-start-pos="5303">바) 회원이 회사의 동의 없이 매출 입금계좌를 임의로 변경한 경우</p>
      <p data-renderer-start-pos="5341">사) 회사가 자체적으로 수립한 회원 유지 기준에 부합하지 않는 경우</p>
      <p data-renderer-start-pos="5380">아) 회원이 정산주체로부터 지급받는 정산금이 불법행위 또는 사회상규에 반하는 행위의 대가인 경우</p>
      <p data-renderer-start-pos="5435">자) 회원의 정산금 출금 등으로 인해 회사가 정산금을 회수하지 못하거나 회수하지 못할 우려가 있는 경우</p>
      <p data-renderer-start-pos="5494">&nbsp;</p>
      <ol class="ak-ol" data-indent-level="1">
      <li>
      <p data-renderer-start-pos="5499">회원이 서비스 이용 약정을 해지하고자 할 경우에는 회사가 정한 별도의 방법을 이용하여 서비스 해지 신청을 할 수 있다. 이 경우 회사는 정해진 해지 절차를 거쳐 해지를 요청한 회원의 정보는 &ldquo;개인정보취급방침&rdquo;에 따라 처리하며 이용계약은 회사가 회원의 해지 신청을 승낙했을 때에 종료된다.</p>
      </li>
      </ol>
      <p data-renderer-start-pos="5663">가) 회원은 회사의 고객센터 (유선 및 온라인 상담)를 통해 서비스 해지 요청을 할 수 있다.</p>
      <p data-renderer-start-pos="5717">나) 회사는 해지를 요청한 회원의 신규 선정산금 지급은 서비스 해지 처리가 완료될 때까지 중지한다.</p>
      <p data-renderer-start-pos="5774">다) 회사가 정산금을 모두 수령한 후 회원이 해지를 요청하였음에도 회사의 지정 계좌로 회원의 정산금이 입금되는 경우 해지처리가 완료되는 일자에 모든 과입금액을 회원이 회사에 사전에 등록한 입금 계좌로 지급한다.</p>
      <p data-renderer-start-pos="5893">라)회사는 위 다)항의 내용이 모두 완료된 것을 확인 후 회원이 기 동의하였던 출금이체 동의를 해제하고 최종 서비스 해지 처리를 완료한다.</p>
      <p data-renderer-start-pos="5972">&nbsp;</p>
      <p data-renderer-start-pos="5975"><strong data-renderer-mark="true">제 12조(면책조항)</strong></p>
      <ol class="ak-ol" data-indent-level="1">
      <li>
      <p data-renderer-start-pos="5990">천재지변, 전쟁, 금융회사 또는 제휴사의 사유, 기타 불가항력으로 본 서비스를 제공할 수 없을 경우에 회사는 본 서비스 제공에 관한 책임을 지지 아니한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="6080">정산주체로부터의 자료에 오류가 발생하거나 회원의 고의 또는 과실로 인하여 발생된 회원의 손해에 대해서는 회사가 책임지지 아니한다.</p>
      </li>
      <li>
      <p data-renderer-start-pos="6156">회원이 본 서비스를 이용함에 있어서 본 약관 또는 관계 법령을 위반하여 야기되는 문제나 손실에 대하여는 회사가 책임을 지지 아니하며, 이로 인하여 회사가 손해를 입을 경우에는 회원이 회사에 배상하여야 한다.</p>
      </li>
      </ol>
      <p data-renderer-start-pos="6275"><strong data-renderer-mark="true">제 13조(약정기한)</strong></p>
      <p data-renderer-start-pos="6288">각 제휴서비스 별 의무약정기한에 따른다. 단 서비스를 해지하고자 할 땐 *일 전에 미리 회사가 정한 방법으로 해지 신청을 해야 한다.</p>
      <p data-renderer-start-pos="6364">&nbsp;</p>
      <p data-renderer-start-pos="6367"><strong data-renderer-mark="true">제 14조(서비스 업무의 위탁 및 동의)</strong></p>
      <p data-renderer-start-pos="6391">회사는 회원이 신청한 서비스 업무를 위해 본 서비스에 대한 업무를 협력사에 위탁할 수 있고, 회원은 원활한 서비스 업무 협력을 위해 회사가 회사의 서비스 신청에 등록된 회원의 정보 및 개인(신용)정보를 협력사에 제공하는 것에 동의합니다.</p>
      <div class="sc-eNQAEJ rAVIf">&nbsp;</div>
      <div class="pm-table-container  sc-kkGfuU gqJIVH" data-layout="default">
      <div class="pm-table-wrapper">
      <table data-number-column="false"><colgroup><col /><col /></colgroup>
      <tbody>
      <tr>
      <th class="ak-renderer-tableHeader-sortable-column" colspan="1" rowspan="1" data-colwidth="340" aria-sort="none">
      <div class="ak-renderer-tableHeader-sortable-column__button" tabindex="0" role="button" aria-disabled="false">
      <p data-renderer-start-pos="6528"><strong data-renderer-mark="true">수탁업체</strong></p>
      <figure class="ak-renderer-tableHeader-sorting-icon ak-renderer-tableHeader-sorting-icon__no-order" aria-hidden="true">
      <div role="presentation">&nbsp;</div>
      </figure>
      </div>
      </th>
      <th class="ak-renderer-tableHeader-sortable-column" colspan="1" rowspan="1" data-colwidth="340" aria-sort="none">
      <div class="ak-renderer-tableHeader-sortable-column__button" tabindex="0" role="button" aria-disabled="false">
      <p data-renderer-start-pos="6536"><strong data-renderer-mark="true">위탁 업무의 내용</strong></p>
      <figure class="ak-renderer-tableHeader-sorting-icon ak-renderer-tableHeader-sorting-icon__no-order" aria-hidden="true">
      <div role="presentation">&nbsp;</div>
      </figure>
      </div>
      </th>
      </tr>
      <tr>
      <td colspan="1" rowspan="1" data-colwidth="340">
      <p data-renderer-start-pos="6584">인포뱅크㈜ , 주식회사 카카오</p>
      </td>
      <td colspan="1" rowspan="1" data-colwidth="340">
      <p data-renderer-start-pos="6604">안내 메시지 발송</p>
      </td>
      </tr>
      </tbody>
      </table>
      </div>
      </div>
      <p data-renderer-start-pos="6618">&nbsp;</p>
      <p data-renderer-start-pos="6621"><strong data-renderer-mark="true">제 15조(해석 및 관할법원)</strong></p>
      <p data-renderer-start-pos="6639">본 약정서에서 정하지 않은 사항은 특약사항을 우선으로 하여 관계법령과 일반적인 상관례에 따른다. 본 약정과 관련하여 회사와 회원간에 소송상 분쟁이 발생한 경우에는 회사의 주소지 관할법원을 전속적, 배타적 관할법원으로 하여 분쟁을 해결하기로 한다.</p>
      <p data-renderer-start-pos="6778">&nbsp;</p>
      <p data-renderer-start-pos="6781">부칙</p>
      <p data-renderer-start-pos="6785">본 이용약관은 2022년 4월 1일부터 적용된다.</p>
    `,
    uuid: 'dfsdfsdfsdf',
    code: 'SERVICE1',
  },
]
